import axiosInstance from ".";

export const getFooter = () => {
  return axiosInstance.get("/footer");
};

export const updateFooter = (data) => {
  return axiosInstance.post("/footer", data);
};
